import React from "react";
import { Card, CardContent, Typography, Grid, Skeleton } from "@mui/material";

const AuthenticationMetricsComponent = (props) => {
    const { breakpoints, selectedRange, totalAuthenticationCount, isFetchingTotalAuthentication } = props;

    // Function to get default values for each level
    const getDefaultValues = () => ({
        MPL: 0,
        BL: 0,
        RL: 0,
    });

    // Function to map API response data to card properties
    const getTitleAndValue = (key, value) => {
        let title;
        switch (key) {
            case 'MPL':
                title = "Pallet Level";
                break;
            case 'RL':
                title = "Retail Level";
                break;
            case 'BL':
                title = "Box Level";
                break;
            default:
                title = "Unknown";
        }

        return {
            value: value.toString(),
            color: "#3333cf",
            title: title,
            backgroundColor: "#3333cf0f",
            borderColor: "#3333cf",
            fontSize: "40px"
        };
    };

    const prepareCardData = () => {
        const defaultValues = getDefaultValues();

        const dataFromApi = (totalAuthenticationCount || []).reduce((acc, item) => {
            const key = Object.keys(item)[0];

            if (defaultValues[key] !== undefined) {
                acc[key] = item[key];
            }

            return acc;
        }, {});

        const finalData = { ...defaultValues, ...dataFromApi };
        const dataArray = Object.keys(finalData).map(key => getTitleAndValue(key, finalData[key]));

        return dataArray;
    };
    

    const cardData = prepareCardData();

    return (
        <Grid container spacing={1.5}>
            {isFetchingTotalAuthentication ?
                cardData.map((_, index) => (
                    <Grid item xs={12} sm={4} key={index}>
                        <Card variant="outlined" sx={{ backgroundColor: "#3333cf0f", border: "0.1px solid #3333cf", borderRadius: "8px", height: '100%' }}>
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                <Skeleton variant="text" width={100} height={80} sx={{backgroundColor: "rgb(108 139 222 / 30%)", mt: "5px"}} />
                                <Skeleton variant="text" width={60} height={20} sx={{backgroundColor: "rgb(108 139 222 / 30%)", mt: "5px"}} />
                                <Skeleton variant="text" width={80} height={50} sx={{backgroundColor: "rgb(108 139 222 / 30%)", mt: "5px"}} />
                            </CardContent>
                        </Card>
                    </Grid>
                ))
            :
                cardData.map((card, index) => (
                    <Grid item xs={12} sm={4} key={index}>
                        <Card variant="outlined" sx={{ backgroundColor: card.backgroundColor, border: `0.1px solid ${card.borderColor}`, borderRadius: "8px" }}>
                            <CardContent sx={{ pb: "16px !important", textAlign: 'center' }}>
                                <Typography variant="body2" sx={{ fontSize: card.fontSize, color: card.color, fontWeight: "bold", mt: "5px" }}>
                                    {card.value}
                                </Typography>
                                <Typography variant="body2" sx={{ fontSize: "16px", color: "#58565f", mt: "1px" }}>
                                    OVI
                                </Typography>
                                <br />
                                <Typography variant="body2" sx={{ fontSize: "18px", color: "#58565f", fontWeight: "bold" }}>
                                    {card.title}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))
            }
        </Grid>
    );
};

export default AuthenticationMetricsComponent;
